import React from 'react'
import ContentLoader from 'react-content-loader'

const OperationsLoader = () => {
//   if (window.isMobile() == 'desktop') {
    return (
      <ContentLoader preserveAspectRatio='none' viewBox="0 0 400 130" style={{padding: '32px 0px'}}>
        <rect x='0' y='0' width={223 / 3} height={120 / 3} />
        <rect x={(223 / 3) + (17 / 3)} y='0' width={228 / 3} height={55 / 3} />
        <rect x={(223 / 3) + (228 / 3) + (17 / 3) + (17 / 3)} y='0' width={228 / 3} height={55 / 3} />
        <rect x={(223 / 3) + (228 / 3) + (17 / 3) + (17 / 3) + (228 / 3) + (17 / 3)} y='0' width={228 / 3} height={55 / 3} />
        <rect x={(223 / 3) + (228 / 3) + (17 / 3) + (17 / 3) + (228 / 3) + (17 / 3) + (228 / 3) + (17 / 3)} y='0' width={228 / 3} height={55 / 3} />

        <rect x={(223 / 3) + (17 / 3)} y={(55 + 10) / 3} width={228 / 3} height={55 / 3} />
        <rect x={(223 / 3) + (228 / 3) + (17 / 3) + (17 / 3)} y={(55 + 10) / 3} width={228 / 3} height={55 / 3} />
        <rect x={(223 / 3) + (228 / 3) + (17 / 3) + (17 / 3) + (228 / 3) + (17 / 3)} y={(55 + 10) / 3} width={228 / 3} height={55 / 3} />
        <rect x={(223 / 3) + (228 / 3) + (17 / 3) + (17 / 3) + (228 / 3) + (17 / 3) + (228 / 3) + (17 / 3)} y={(55 + 10) / 3} width={228 / 3} height={55 / 3} />

        <rect x='50' y='60' rx='4' ry='4' width='300' height='13' />
        <rect x='50' y='80' rx='4' ry='4' width='300' height='5' />
      </ContentLoader>

    )
//   }
//  else {
//     return (
//       <ContentLoader preserveAspectRatio='none' height='350'>
//         <rect x='50' y='0' width='30%' height={100} />
//         <rect x='50%' y='0' width='30%' height={100} />
//         <rect x='50' y='120' width='30%' height={100} />
//         <rect x='50%' y='120' width='30%' height={100} />
//         <rect x='50' y='240' width='30%' height={100} />
//         <rect x='50%' y='240' width='30%' height={100} />

//       </ContentLoader>

//     )
//   }
}

export default OperationsLoader
